import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';
import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { getQueryParams } from 'constants/helper';
import { routes } from 'constants/routes';

const useReviewFormParams = () => {
  const location = useLocation();
  const reviewFormFillingRoute = checkNewNavEnabled()
    ? staticRoutesWithCustomSidebar.reviewsFormFilling
    : routes.performanceReview.forms;

  const reviewResultPageRoute = checkNewNavEnabled()
    ? staticRoutesWithCustomSidebar.reviewsResultPage
    : routes.performanceReview.result;

  let match =
    matchPath(location.pathname, {
      path: reviewFormFillingRoute,
      exact: true,
    }) ?? {};
  if (!match.params?.employeeId) {
    match =
      matchPath(location.pathname, {
        path: reviewResultPageRoute,
        exact: true,
      }) ?? {};
  }
  const { employeeId, reviewId } = match.params ?? {};
  const queryParams = getQueryParams(location.search);
  const loggedInEmployee = useSelector(selectLoggedInEmployeeData);

  const providerId = queryParams.provider || loggedInEmployee?.id;
  return {
    employeeId,
    reviewId,
    providerId,
  };
};

export default useReviewFormParams;
